import React from "react";
import { node } from "prop-types";
import { motion } from "framer-motion";
import styles from "./LoadingScreen.module.scss";
import Logo from "./Logos/Logo";
import NzHumanRightsLogo from "./Logos/NzHumanRightsLogo";
import TcAnzLogo from "./Logos/TcAnzLogo";
import GiveNothingLogo from "./Logos/GiveNothingLogo";

export default function LoadingScreen({ children }) {
  let flexBasisPattern = "30%";
  let flexBasisLogo = "70%";
  let duration = 1;
  let opacity = 0;
  let width = "268px";
  let justifyContent = "center";

  if (children) {
    flexBasisPattern = "0%";
    flexBasisLogo = "100%";
    opacity = 1;
    width = "205px";
    justifyContent = "start";
  }

  const ChildContainer = (
    <motion.div
      initial={{
        y: 26 * 1.2,
        opacity: 0,
        maxHeight: "0px",
        overflow: "hidden",
      }}
      animate={{ y: 0, opacity: 1, maxHeight: "1000px" }}
      transition={{ duration }}
      className={styles.childContainer}
    >
      {children}
    </motion.div>
  );

  return (
    <div id="loading" className={styles.container}>
      <motion.div
        initial={false}
        animate={{
          flexBasis: flexBasisLogo,
        }}
        transition={{ duration }}
        className={styles.logoContainer}
      >
        <motion.div
          initial={{ display: "flex", justifyContent, width }}
          animate={{
            justifyContent,
            width,
          }}
          transition={{ duration }}
        >
          <Logo />
          <h1 className="u-visually-hidden">Unteach Racism logo</h1>
        </motion.div>

        {children && ChildContainer}
      </motion.div>

      <motion.div
        initial={{ opacity }}
        animate={{ opacity }}
        transition={{ duration }}
        className={styles.subLogoContainer}
      >
        <TcAnzLogo />

        <GiveNothingLogo />

        <NzHumanRightsLogo />
      </motion.div>

      <motion.div
        layout
        initial={false}
        animate={{
          flexBasis: flexBasisPattern,
        }}
        transition={{ duration }}
        className={styles.patternContainer}
      >
        <div className={styles.patternBackground} />
      </motion.div>
    </div>
  );
}

LoadingScreen.propTypes = {
  children: node,
};
